<mat-toolbar color="accent" class="ma-0 mat-text-white box-shadow" [ngClass]="{'onhold': call.isOnhold()}" fxLayout="row"
  fxLayoutAlign="start center" fxLayoutGap="10px" (click)="showActiveCall()">
  <mat-icon class="text-green">phone</mat-icon>
  <div class="border"></div>
  <div fxFlex="auto" class="font-weight-normal font-18">{{ call.remoteNumberInLocalFormat() }}</div>
  <div fxFlex="100px" fxLayoutAlign="start center" fxLayoutGap="5px" *ngIf="call.isAnswered()" class="ml-1">
      <ng-container *ngIf="call.answerTime && !call.isOnhold()">
        <mat-icon class="mat-text-white font-weight-normal">access_time</mat-icon>
        <timer-since [since]="call.answerTime" class="call-timmer font-18"></timer-since>
      </ng-container>

      <ng-container *ngIf="call.onholdTime && call.isOnhold()">
        <mat-icon class="mat-text-white font-weight-normal">pause_presentation</mat-icon>
        <timer-since [since]="call.onholdTime" class="call-timmer font-18"></timer-since>
      </ng-container>
  </div>
  <div class="wrapper-anim">
      <div class="loader-call-anim">Loading...</div>
  </div>
</mat-toolbar>
